import React, { useEffect } from "react";
import style from "./MyOffers.module.css";
import Top from "../../components/MainContent/Header/Top/Top";
import SideBanner from "../../components/SideBanner/SideBanner";
import Footer from "../../components/MainContent/Body/Footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import {
  CompanyType,
  fetchUserCompanies,
  selectCompanies,
} from "../../slices/company/companySlice";
import { NavLink } from "react-router-dom";
import OneMyOffer from "./OneMyOffer/OneMyOffer";
import { Button } from "@mui/material";

const MyOffers: React.FC = () => {
  const dispatch = useDispatch();;

  useEffect(() => {
    dispatch(fetchUserCompanies());
  }, [dispatch]);

  const companies: CompanyType[] = useSelector(selectCompanies);

  return (
    <div className={style.Content}>
      <SideBanner side="left" />

      <div className={style.Offer}>
        <div className={style.TopAndBorder}>
          <Top />
          <div className={style.Border} />
        </div>

        <div className={style.PageAndFooter}>
          <div className={style.Offers}>
            {companies.map((offer: CompanyType) => {
              const now = new Date();

              const hasActiveExtended =
                !!offer.expirationDate &&
                new Date(offer.expirationDate) > now;

              const isPromotiondDisabled =
                !hasActiveExtended ||
                (
                  !!offer.highlightedExpirationDate &&
                  new Date(offer.highlightedExpirationDate) > now
                ) ||
                offer.newIsHighlighted ||
                offer.addHighlighted ||
                offer.addRecommended ||
                offer.newIsRecommended ||
                !offer.isActive;

              const isExtendDisabled =
                offer.addNewPeriod ||
                offer.newIsHighlighted ||
                offer.addHighlighted ||
                !offer.isActive;

              return (
              
              <React.Fragment key={offer._id}>
                <OneMyOffer
                  name={offer.name}
                  shortName={offer.shortName}
                  website={offer.website}
                  email={offer.email}
                  phone={offer.phone}
                  NIP={offer.NIP}
                  description={offer.description}
                  mainField={offer.mainField[0]}
                  expirationDate={offer.expirationDate}
                  highlightedExpirationDate={offer.highlightedExpirationDate}
                  recommendedExpirationDate={offer.recommendedExpirationDate}
                  isActive={offer.isActive}
                />

                <div className={style.Row}>
                  <NavLink to={`/edit/offer/${offer._id}`} style={{ textDecoration: "none" }}>
                    <Button>Edytuj</Button>
                  </NavLink>

                  {isPromotiondDisabled ? (
                    <Button disabled>Wypromuj firmę</Button>
                  ) : (
                    <NavLink
                      to={`/promotion/offer/${offer._id}`}
                      style={{ textDecoration: "none" }}
                    >
                      <Button>Wypromuj firmę</Button>
                    </NavLink>
                  )}

                  {isExtendDisabled ? (
                    <Button disabled>Przedłuż</Button>
                  ) : (
                    <NavLink
                      to={`/extend/offer/${offer._id}`}
                      style={{ textDecoration: "none" }}
                    >
                      <Button>Przedłuż</Button>
                    </NavLink>
                  )}
                </div>
              </React.Fragment>
                );
            })}
          </div>
          <Footer />
          </div>
        </div>
      <SideBanner side="right" />
    </div>
  );
};

export default MyOffers;